import moment from "moment";
import { Dropdown } from "react-bootstrap";
import { useEffect, useState } from "react";
import OfflineModal from "../../OfflineLeads/OfflineModal";
import EnquiryCards from "../../Enquiries/EnquiryCards";
import EnquirySearch from "../../Enquiries/EnquirySearch/EnquirySearch";

const OfflineLeads = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [totalPageChange, setTotalPageChange] = useState({
    page: 1,
    limit: 10,
    // order_by: "updatedAt",
    // order_direction: "DESC",
  });
  const adminPersona = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [modalFields, setModalFields] = useState([
    {
      name: "leadName",
      label: "Customer Name",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleCustName(value),
    },
    {
      name: "mobileNumber",
      label: "Mobile No.",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleMobileNo(value),
    },
    {
      name: "productType",
      label: "Product Type",
      type: "select",
      options: [],
      placeholder: "Please enter",
      // outerclass: "readonly_field",
      required: true,
    },
    {
      name: "bankName",
      label: "Bank Name",
      type: "select",
      options: [],
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "loanAmount",
      label: "Loan Amount",
      type: "text",
      placeholder: "Please enter",
      required: true,
      onChange: (value) => handleLoanAmount(value),
    },
    {
      name: "applicationNumber",
      label: "Application No.",
      type: "text",
      required: true,
      placeholder: "Please enter",
    },
    {
      name: "applicationDate",
      label: "Application Date",
      type: "date",
      disabledDate: (current) => {
        return current && current > moment().endOf("day");
      },
      placeholder: "Please enter",
      required: true,
    },
    {
      name: "status",
      label: "Application Status",
      type: "select",
      options: _enum.LOAN_STATUS_NEW,
      placeholder: "Please select",
      required: true,
      onChange: (value) => handleApplicationStatus(value),
    },
    {
      name: "disbursementAmount",
      label: "Disb. Amount",
      type: "text",
      placeholder: "Please enter",
      onChange: (value) => handleDisbAmount(value),
      required: true,
      // outerclass: "d-none",
    },
    {
      name: "disbursementDate",
      label: "Disb. Date",
      type: "date",
      disabledDate: (current) => {
        return current && current < moment().startOf("day");
      },
      placeholder: "Please enter",
      required: true,
      // outerclass: "d-none",
    },
  ]);
  const [applstatus, setApplstatus] = useState("APPLIED");
  const [cardData, setCardData] = useState();
  const [editData, setEditData] = useState({});
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});

  const [rowcount, setRowcount] = useState(0);
  const columns = [
    {
      dataIndex: "leadName",
      title: "Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    // {
    //   dataIndex: "enquired_on",
    //   title: "Enquired On",
    //   render: (text, record) => {
    //     let date = new Date(text).dateToDDMMYYYY(new Date(text));
    //     if (text) {
    //       return date;
    //     } else {
    //       return "-";
    //     }
    //   },
    // },
    {
      dataIndex: "mobileNumber",
      title: "Mobile No.",
    },
    {
      dataIndex: "productType",
      title: "Product Type",
    },
    {
      dataIndex: "loanAmount",
      title: "Loan Amount",
      render: (text) => {
        return <>{text?.cur(0)}</>;
      },
    },
    {
      dataIndex: "disbursementAmount",
      title: "Disb. Amt.",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "disbursementDate",
      title: "Disb. Date",
      render: (text, record) => {
        if (record?.disbursementDate) {
          let date = new Date(text).dateToDDMMYYYY(new Date(text));
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";

        let dropdowItems;
        let { role } = props?.$store?.user || {};
        if (role === _enum.ROUTE_PERSONAS.ops) {
          dropdowItems = _enum?.OPS_LEADS_STATUS?.filter(
            (v) => v.key !== "open"
          );
        } else {
          dropdowItems = _enum?.ADMIN_LEADS_STATUS?.filter(
            (v) => v.key !== "open"
          );
        }
        return (
          <Dropdown
            className={Object.className({
              "status-dropdown": true,
              "no-arrow pe-none": true,
            })}
          >
            <Dropdown.Toggle as="div" className={`${mappedStatus}`}>
              <span>{record?.status?.toTitleCase() || "-"}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: "status",
      title: "Payment Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.paymentStatus?.toLowerCase()] || "";

        let dropdowItems;
        let { role } = props?.$store?.user || {};
        if (role === _enum.ROUTE_PERSONAS.ops) {
          dropdowItems = _enum?.OPS_LEADS_STATUS?.filter(
            (v) => v.key !== "open"
          );
        } else {
          dropdowItems = _enum?.ADMIN_LEADS_STATUS?.filter(
            (v) => v.key !== "open"
          );
        }
        return (
          <Dropdown
            className={Object.className({
              "status-dropdown": true,
              "no-arrow pe-none": true,
            })}
          >
            <Dropdown.Toggle as="div" className={`${mappedStatus}`}>
              <span>{record?.paymentStatus?.toTitleCase() || "-"}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const getApplications = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, [
        "limit",
        "page",
        // "order_by",
        // "order_direction",
      ]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
      // console.log({ defaultSearchData: payload });
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis
      .apiGetApplications(payload)
      .then(({ data, total }) => {
        console.log({ apiGetApplications: data });
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      })
      .catch((err) => console.error(err));
  };

  const getApplication = (record) => {
    let urlData = {
      applicationLeadId: record.applicationLeadId,
    };
    // GET APPLICATION BY ID
    props.apis.apiGetApplicationById(urlData).then((response) => {
      console.log({ apiGetApplicationById: response });

      let filteredData = {
        leadName: response?.leadName,
        mobileNumber: response?.mobileNumber,
        productType: response?.productType,
        bankName: response?.bankName,
        loanAmount: response?.loanAmount,
        applicationDate: response?.applicationDate
          ?.moment()
          ?.format("DD-MM-YYYY"),
        applicationNumber: response?.applicationNumber,
        status: response?.status,
        ...(response?.disbursementAmount
          ? {
              disbursementAmount: response?.disbursementAmount,
            }
          : {}),
        ...(response?.disbursementDate
          ? {
              disbursementDate: response?.disbursementDate
                ?.moment()
                ?.format("DD-MM-YYYY"),
            }
          : {}),
      };

      // console.log({ filteredData });
      setPopupdata(filteredData);
      setEditData(response);
      openModal();

      var disbamntField = modalFields.find(
        (o) => o.name === "disbursementAmount"
      );
      var disbdateField = modalFields.find(
        (o) => o.name === "disbursementDate"
      );
      // if (disbamntField?.outerclass?.includes("d-none")) {
      //   disbamntField.outerclass = disbamntField.outerclass
      //     .replace("d-none", "")
      //     .trim();
      // }
      // if (disbdateField?.outerclass?.includes("d-none")) {
      //   disbdateField.outerclass = disbdateField.outerclass
      //     .replace("d-none", "")
      //     .trim();
      // }
      if (response?.status === _enum?.LOAN_STATUS_MAP?.disbursed) {
        if (disbamntField?.outerclass?.includes("d-none")) {
          disbamntField.outerclass = disbamntField.outerclass
            .replace("d-none", "")
            .trim();
        }
        if (disbdateField?.outerclass?.includes("d-none")) {
          disbdateField.outerclass = disbdateField.outerclass
            .replace("d-none", "")
            .trim();
        }
        setModalFields([...modalFields]);
      } else {
        disbamntField.outerclass = "d-none";
        disbdateField.outerclass = "d-none";
      }
    });
  };

  const viewApplication = (record) => {
    setEditmode(false);
    setViewmode(true);
    // GET OFFLINE LEADS BY ID
    // UPDATE OFFLINE LEADS BY ID
    getApplication(record);
  };

  const getLeadsDashboardInfo = () => {
    props.apis.apiGetLeadsDashboardInfo().then((res) => {
      console.log({ res });
      setCardData(res);
    });
  };

  const getBankNames = () => {
    let payload = {
      page: 1,
    };
    props.apis.apiGetBanknames(payload).then((data) => {
      let bankNameField = modalFields.find((o) => o.name === "bankName");
      bankNameField.options = data;
      setModalFields([...modalFields]);
    });
  };

  const getProductTypes = () => {
    props.apis.apiGetProductTypes().then((res) => {
      let productType = modalFields.find((o) => o.name == "productType");
      productType.options = res;
      setModalFields([...modalFields]);
    });
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getApplications();
    } else {
      setSearch({
        ...search,
      });
      getApplications(data, reset);
    }
  };

  const addModalFields = (values) => {
    setEditmode(false);
    setViewmode(false);

    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);

    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onPageChange = (pageData) => {
    console.log({ pageData });
    setTotalPageChange({
      ...search,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const onModalClose = () => {
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    closeModal();
  };
  useEffect(() => {
    getBankNames();
    getProductTypes();
    console.log({ editmode, viewmode });

    if (editmode === false && viewmode === false) {
      // let rname = props?.urlparams?.params?.leadname;
      // console.log(rname);
      // setRouteName(rname);
      // let productType = modalFields.find((o) => o.name == "productType");
      // productType.defaultValue = rname;
      // // productType.readOnly = true;
      // setModalFields([...modalFields]);
    } else {
      // let productType = modalFields.find((o) => o.name == "productType");
      // productType.defaultValue = editData?.productType;
      // setModalFields([...modalFields]);

      setTimeout(() => {
        if (editData?.status !== "DISBURSED") {
          document
            .querySelector('[name="disbursementAmount"]')
            ?.removeAttribute("required");
          document
            .querySelector('[name="disbursementDate"]')
            ?.removeAttribute("required");
        }
      }, 100);
      console.log("not add modal");
    }
  }, [openCanvas]);

  useEffect(() => {
    getLeadsDashboardInfo();
  }, []);

  useEffect(() => {
    getApplications(totalPageChange);
  }, [totalPageChange]);
  return (
    <>
      <div className="container-fluid pb-5 px-lg-5">
        <div className="row">
          <div className="col-xl-12">
            <EnquiryCards />

            <div className="card h-auto">
              <div className="card-body p-0">
                <div className="tbl-caption-container justify-content-end">
                  <EnquirySearch
                    onSearch={(...arg) => onSearch(...arg)}
                    addModalFields={addModalFields}
                  />
                </div>
                {!!tableData.length && (
                  <AppTable
                    data={tableData}
                    columns={columns}
                    onChange={(...arg) => onPageChange(...arg)}
                    total={rowcount}
                    reorder={true}
                    editAction={(...args) => editApplication(...args)}
                    viewAction={(...args) => viewApplication(...args)}
                    editable={adminPersona ? false : true}
                    deletable={adminPersona ? false : false}
                    deleteAction={(...args) => deleteApplication(...args)}
                    loading={isFetching}
                    rowSelection={adminPersona ? "" : rowSelection}
                    checkbox={adminPersona ? false : true}
                  ></AppTable>
                )}
                {tableData.length == 0 && <div className="empty_layout"></div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      <OfflineModal
        id="applicationCanvas"
        title={`${
          editmode ? "Edit Lead" : viewmode ? "View Lead" : "Add Lead"
        }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        viewmode={viewmode}
        editmode={editmode}
        errorMessage={errorMessage}
        // noValidate={true}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Save & Submit"}`}
        disableallfields={viewmode ? true : false}
      />
    </>
  );
};

export default constore(OfflineLeads);
